module.exports = __webpack_public_path__ + "static/img/kv03.6f484bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-2/kv03.jpg
// module id = 6QLX
// module chunks = 0